/**
 * 渠道值
 */
import { getQuery } from './url';
let clientType = '-1';

export default function() {
  const qs = getQuery();

  if (clientType !== '-1') {
    return clientType;
  }

  if ($.device) {
    if ($.device.jdapp) {
      clientType = 'mpage';
    } else if ($.device.jdjr) {
      if ($.device.android) {
        clientType = 'android';
      } else {
        clientType = 'ios';
      }
    } else if ($.device.weixin) {
      clientType = 'weixin';
    } else if ($.device.qq) {
      clientType = 'qq';
    } else if ($.device.wallet) {
      clientType = 'wangyin';
    } else if (qs && qs.clientType) {
      clientType = qs.clientType;
    } else if (qs && qs.source) {
      clientType = qs.source;
    } else if ($.device.ipad) {
      clientType = 'ipad';
    } else if ($.device.jdlocal) {
      clientType = 'jdlocal';
    } else {
      clientType = 'sms';
    }
  }

  console.log('clientType', clientType);
  return clientType;
}
